import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    h: {
      i: null,
      j: null,
      k: null,
      l: [],
      m: null,
    },
    kimmuBi: null,
    nengetsu: null,
    torokuBi: null,
    nen: null,
    menuDisable: false,
  },
  getters: {
    shainId: state => {
      return state.h.i;
    },
    shainShimei: state => {
      return state.h.j;
    },
    kengenKubun: state => {
      return state.h.k;
    },
    jochoIds: state => {
      return state.h.l;
    },
    shainKubun: state => {
      return state.h.m;
    },
  },
  mutations: {
    clear (state) {
      state.h = {
        i: null,
        j: null,
        k: null,
        l: [],
        m: null,
      };
      state.kimmuBi = null;
      state.nengetsu = null;
      state.torokuBi = null;
      state.nen = null;
      state.menuDisable = false;
    },
    setLoginUser (state, value) {
      state.h.i = value.shainId;
      state.h.j = value.shainShimei;
      state.h.k = value.kengenKubun;
      state.h.l = [];
      if (value.jochoShainId != null && value.jochoShainId != '') {
        state.h.l.push(value.jochoShainId);
      }
      if (value.jochoShainId2 != null && value.jochoShainId2 != '') {
        state.h.l.push(value.jochoShainId2);
      }
      if (value.jochoShainId3 != null && value.jochoShainId3 != '') {
        state.h.l.push(value.jochoShainId3);
      }
      state.h.m = value.shainKubun;
    },
    setJochoShainIds (state, value) {
      state.h.l = [];
      if (value.jochoShainId != null && value.jochoShainId != '') {
        state.h.l.push(value.jochoShainId);
      }
      if (value.jochoShainId2 != null && value.jochoShainId2 != '') {
        state.h.l.push(value.jochoShainId2);
      }
      if (value.jochoShainId3 != null && value.jochoShainId3 != '') {
        state.h.l.push(value.jochoShainId3);
      }
    },
    setKimmuBi (state, value) {
      state.kimmuBi = value;
    },
    setNengetsu (state, value) {
      state.nengetsu = value;
    },
    setTorokuBi (state, value) {
      state.torokuBi = value;
    },
    setNen (state, value) {
      state.nen = value;
    },
    setMenuDisable (state, value) {
      state.menuDisable = value;
    },
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState({
      key: 'SmartReport',
      storage: window.sessionStorage
  })]
})
